import { useState } from "react";
import APIKeyCopy from "./APIKeyCopy";
import { Button } from "V2.0/common/button";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import { generateKey } from "V2.0/services/keyService";

export default function APIKeyCreate(props) {
  const { workspaceId, fetchKeys } = props;

  const [openAPIDialog, setOpenAPIDialog] = useState({
    isOpen: false,
    apiKey: "",
  });
  const [loading, setLoading] = useState<boolean>(false);

  const handleCreateKey = async function () {
    const lifecycleCbs = {
      onInit: function () {
        message.loading("Generating Key");
        setLoading(true);
      },
      onSuccess: function () {
        message.destroy();
        message.success("Key Generated");
        fetchKeys(workspaceId);
        setLoading(false);
      },
      onError: function (e) {
        message.destroy();
        setLoading(false);
        showErrorToast(e, "Failed to Generate Key");
      },
    };

    lifecycleCbs.onInit();
    try {
      const response = await generateKey(workspaceId);

      if (response.status === 200) {
        lifecycleCbs.onSuccess();
        setOpenAPIDialog({
          isOpen: true,
          apiKey: response.data.apiKey.key,
        });
      }
    } catch (e) {
      lifecycleCbs.onError(e);
    }
  };

  return (
    <>
      <Button
        color="white"
        disabled={loading}
        onClick={handleCreateKey}
      >
        Create Key
      </Button>
      {openAPIDialog.isOpen && (
        <APIKeyCopy
          apiKey={openAPIDialog.apiKey}
          onClose={() => {
            setOpenAPIDialog({
              isOpen: false,
              apiKey: "",
            });
          }}
        />
      )}
    </>
  );
}
